import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import { Form, Row, Col, Card } from '@beehive/components';
import _ from 'lodash';
import { SUPPLIER_CONTRACTS_KEYS, CONTRACTS_TYPES } from '../utils';
import { renderForm } from './BasicInfo';
import PropTypes from 'prop-types';
import contactsMessages from 'messages/Models/SupplierContact';
import titleMessages from 'messages/CompanyManagement/CardTitle';

const messages = { ...contactsMessages, ...titleMessages };

interface HandleChangeItem {
  key: string;
  value: string | number;
  item: any;
}

export interface SupplierContactsProps {
  data: types.SupplierMangementDetail;
  onChange: any;
}

class SupplierContacts extends React.Component<SupplierContactsProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: SupplierContactsProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: SupplierContactsProps) {
    const pickKeys = ['data.supplier_contacts', 'data.detailError.messages',
      'data.loading', 'data.loaded', 'data.change_detail'];
    const thisData = _.pick(this.props, pickKeys);
    const nextData = _.pick(nextProps, pickKeys);
    if (_.isEqual(thisData, nextData)) {
      return false;
    }
    return true;
  }

  // 修改内容
  private handleChange = (options: HandleChangeItem) => {
    const { onChange, data, data: { change_detail = {} } } = this.props;
    const { supplier_contacts = [] } = data;
    const { key, value, item } = options;
    const newSupplierContacts = _.cloneDeep(supplier_contacts);
    let contract = newSupplierContacts.find((i: types.SupplierContact) => i.contact_type === item.contact_type);

    if (!contract) {
      newSupplierContacts.push(item);
      contract = item;
    }
    if (contract) {
      contract[key] = value;
    }
    const newData = {
      ...data,
      change_detail: {
        ...change_detail,
        [item.contact_type]: {
          ..._.get(change_detail, item.contact_type, {}),
          [key]: value,
        },
      },
    };
    onChange(newData);
  }

  public render() {
    const { intl } = this.context;
    const { data } = this.props;
    const { supplier_contacts = [], loading, change_detail = {} } = data;

    return (
      <Card
        titleNode={intl.formatMessage(messages.supplierContacts)}
        loading={loading}
        className="contacts-info"
      >
        <Row gutter={60}>
          {
            CONTRACTS_TYPES.map((ct: string, idx: number) => {
              const contract = supplier_contacts.find((i: any) => i.contact_type === ct) || { contact_type: ct };
              const changedContract = _.get(change_detail, contract.contact_type, {});
              return (
                <Col span={12} key={ct}>
                  <Form isLabelVertical mode="edit">
                    {
                      Object.keys(SUPPLIER_CONTRACTS_KEYS).map((key: string) => {
                        const item = SUPPLIER_CONTRACTS_KEYS[key];
                        let value = contract[key];
                        if (key in changedContract) {
                          value = changedContract[key];
                        }
                        const label = typeof item.label === 'string' ? item.label : item.label[idx];
                        return (
                          <Form.Item
                            itemKey={`supplier_contacts.${key}`}
                            label={label && intl.formatMessage(messages[label])}
                            required={!!item.required}
                            key={key}
                            itemColProps={{ span: 24 }}
                          >
                            {
                              renderForm({
                                key, value,
                                data: SUPPLIER_CONTRACTS_KEYS,
                                handleChange: ((options: any) => this.handleChange({ ...options, item: contract })),
                              })
                            }
                          </Form.Item>
                        );
                      })
                    }
                  </Form>
                </Col>
              );
            })
          }
        </Row>
      </Card>
    );
  }
}

export default SupplierContacts;
